import { Clear } from "@mui/icons-material";
import { TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
export const MyDropdown = (props) => {
  const { t } = useTranslation();
  let error = props.helperText !== "" && props.helperText !== null && props.helperText !== undefined;
  return (
    <Autocomplete
      size={props.size ? props.size : "medium"}
      options={props.options}
      freeSolo={props.freeSolo}
      getOptionLabel={(option) => {
        return option.value ? option.value.toString() : option.toString();
      }}
      fullWidth={props.fullWidth != null ? props.fullWidth : true}
      onChange={props.onChange}
      disableClearable={props.disableClearable ? props.disableClearable : false}
      value={props.value ? props.value : null}
      popupIcon={<ArrowDropDownIcon aria-label={t("open")} />}
      clearIcon={<Clear fontSize="small" aria-label={t("close")} />}
      renderInput={(params) => (
        <TextField
          {...params}
          helperText={props.helperText}
          error={error}
          value={props.value}
          placeholder={props.placeholder}
          required={props.required}
          onChange={props.freeSolo ? props.onFreeSolo : null}
          label={props.label}
          variant="outlined"
          style={{ width: "100%", margin: "1rem 0", ...props.style }}
          className={props.className}
          // inputProps={{
          //   ...params.inputProps,
          //   onKeyDown: (e) => {
          //     if (e.key === "Enter") {
          //       e.stopPropagation();
          //     }
          //   },
          // }}
        />
      )}
    />
  );
};
